// PRICING
document.addEventListener('DOMContentLoaded', function() {
  const pricingCalculatorWrap = document.querySelector('.c-pricing-calculator_wrap');
  if(pricingCalculatorWrap){
    // STARTING VARIABLES
    let isDragging = false,
        userAmount = 1,
        perUserPrice = 99,
        finalPrice = userAmount * perUserPrice,
        billingOption = 'monthly';


    // PER USER PRICING CALC
    function calculatePerUserPricing(userAmount, billingOption){
      if(userAmount <= 25){
        perUserPrice = 99;
      } else if(userAmount > 25 && userAmount <= 49){
        perUserPrice = 89;
      } else if(userAmount == 50){
        perUserPrice = 0;
      }

      if (billingOption == 'annual'){
        if(userAmount != 50){
          perUserPrice = perUserPrice - 10;
        }
      }

      // SET PER USER PRICE
      document.querySelector('.c-pricing-price div:first-child').textContent = '$' + perUserPrice;
      if(perUserPrice == 0){
        document.querySelector('.c-pricing-price div:first-child').textContent = 'Contact Us';
        document.querySelector('.c-pricing-price div:last-child').textContent = ' ';
      }

      // SET TOTAL PRICE
      finalPrice = userAmount * perUserPrice;
      document.querySelector('.c-pricing-total div:first-child').textContent = '$' + finalPrice + ' total per month';
      if(userAmount == 50){
        document.querySelector('.c-pricing-total div:first-child').textContent = '';
        document.querySelector('.c-pricing-total div:last-child').textContent = '';
      } else{
        document.querySelector('.c-pricing-total div:last-child').textContent = '/ user / month';

        if(billingOption == 'monthly'){
          document.querySelector('.c-pricing-total div:last-child').textContent = 'Billed Monthly';
        } else if(billingOption == 'annual'){
          document.querySelector('.c-pricing-total div:last-child').textContent = 'Billed Annually';
        }
      }

      // SET USER AMOUNT
      document.querySelector('.c-pricing-users div').textContent = userAmount;
    }

    // USER SLIDER
    document.querySelector('.c-pricing-slider').addEventListener('touchstart', function(){
      isDragging = true;
    });
    document.querySelector('.c-pricing-slider').addEventListener('mousedown', function(){
      isDragging = true;
    });
    document.querySelector('.c-pricing-slider').addEventListener('touchmove', function(){      
      if(isDragging){
        userAmount = document.querySelector('.c-pricing-slider').value;
        calculatePerUserPricing(userAmount, billingOption);
      }
    });
    document.querySelector('.c-pricing-slider').addEventListener('mousemove', function(){
      if(isDragging){
        userAmount = document.querySelector('.c-pricing-slider').value;
        calculatePerUserPricing(userAmount, billingOption);
      }
    });
    document.querySelector('.c-pricing-slider').addEventListener('touchend', function(){
      isDragging = false;
    });
    document.querySelector('.c-pricing-slider').addEventListener('mouseup', function(){
      isDragging = false;
    });

    // DURATION TOGGLE
    document.querySelectorAll('.c-pricing-toggle input[type="radio"]').forEach(function(el){
      el.addEventListener('change', function(){
        billingOption = this.value;
        calculatePerUserPricing(userAmount, billingOption);
      });
    });
  }
});